//@flow
import React from 'react';
import {Route, Switch} from "react-router";
import {
    ROUTE_PAGE_LOGIN,
} from "./routes";

import NotFound from "../pages/notFound/notFound";

const ROUTES = [
    ROUTE_PAGE_LOGIN,
];

const UnauthenticatedRouter = () => {
    return (
        <Switch>
            {ROUTES.map(route => {
                const {key, path, exact, component} = route;

                return (
                    <Route
                        key={key}
                        path={path}
                        exact={exact}
                        component={component}
                    />
                );
            })}

            <Route>
                <NotFound />
            </Route>
        </Switch>
    );
};

export default UnauthenticatedRouter;